module.exports = __webpack_public_path__ + "static/img/home_bg20.c59b3db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_bg20.jpg
// module id = 50jk
// module chunks = 2